// @todo need desktop styles
import { styled } from "styled-components";
import Colors from "../../../styles/Colors";
import { mediaQueries } from "../../../styles";
import rem from "../../../utils/rem";
export const StyledH1 = styled.h1 `
  font-weight: 500;
  color: ${Colors.BLACK};
  font-size: ${rem(24)};
  line-height: ${rem(32)};
  margin: 0 0 1rem 0;
  ${mediaQueries.up("medium") `
    font-size: ${rem(52)};
    line-height: ${rem(64)};
    font-weight: bold;
  `}
`;
export const StyledH2 = styled.h2 `
  font-weight: 500;
  color: ${Colors.BLACK};
  font-size: ${rem(20)};
  line-height: ${rem(26)};
  margin: 0 0 1rem 0;

  ${mediaQueries.up("medium") `
    font-size: ${rem(24)};
    line-height: ${rem(30)};
    font-weight: bold;
  `}
`;
export const StyledH3 = styled.h3 `
  font-weight: 500;
  color: ${Colors.BLACK};
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  margin: 0 0 1rem 0;

  ${mediaQueries.up("medium") `
    font-size: ${rem(18)};
    line-height: ${rem(28)};
  `}
`;
// @todo need desktop styles
export const StyledHeaderWithIcon = styled.h1 `
  color: ${Colors.GRAY_DARKEST};
  font-weight: ${(props) => props.textWeight || 400};
  display: flex;
  align-items: center;
  > svg {
    margin-right: 18px;
  }
  font-size: ${rem(20)};
  margin: 0 0 1rem 0;
`;
//# sourceMappingURL=styles.js.map